const stickyTopContentId = `stickyTopContent`
const productListContainerId = `productListContainer`
// to allow scrolling to the selected addon category within the product detail
const addonCategoryScrollContainerId = `addonScrollContainer`
const addonListContainerId = `addonListContainer`
const addonStickyContentId = `addonCategoryButtons`

/**
 * IDs used to reference some component on the MenuScreen,
 * they are kept here to remain in one place (and peace)
 */
export const menuScreenElementIds = {
  stickyTopContentId,
  addonListContainerId,
  addonStickyContentId,
  productListContainerId,
  addonCategoryScrollContainerId,
}
